import type {
  CustomerInsightsAlert,
  CustomerInsightsRecord,
} from '../types/CustomerInsightsViewModel';

export interface CustomerInsightsGridFields {
  state: readonly string[];
  type: readonly string[];
  owner: readonly string[];
  subtitle: readonly string[];
  vehicleTitle: readonly string[];
  code: readonly string[];
  occurredAt: readonly string[];
  leadQuality: readonly string[];
  amount: readonly string[];
}

const BUSINESS_CASE_GRID_FIELDS: CustomerInsightsGridFields = {
  state: ['businessCaseState'],
  type: ['businessCaseType'],
  owner: ['author'],
  subtitle: [],
  vehicleTitle: ['vehicle'],
  code: ['businessCaseCustomCode', 'businessCaseId'],
  occurredAt: ['businessCaseClosedAt', 'lastActivityDate', 'businessCaseCreatedAt'],
  leadQuality: [],
  amount: [],
};

const INTEREST_GRID_FIELDS: CustomerInsightsGridFields = {
  state: ['state'],
  type: ['type'],
  owner: ['owner'],
  subtitle: [],
  vehicleTitle: ['vehicle'],
  code: ['code'],
  occurredAt: ['updatedAt', 'createdAt'],
  leadQuality: ['leadQuality'],
  amount: [],
};

const SERVICE_CASE_GRID_FIELDS: CustomerInsightsGridFields = {
  state: ['state'],
  type: [],
  owner: [],
  subtitle: ['name'],
  vehicleTitle: ['vehicle'],
  code: ['number', 'name'],
  occurredAt: ['handoverDate', 'updatedAt', 'createdAt'],
  leadQuality: [],
  amount: [],
};

const INVOICE_GRID_FIELDS: CustomerInsightsGridFields = {
  state: [],
  type: [],
  owner: [],
  subtitle: [],
  vehicleTitle: [],
  code: ['number'],
  occurredAt: ['dueDate'],
  leadQuality: [],
  amount: ['priceWithVat'],
};

const TASK_GRID_FIELDS: CustomerInsightsGridFields = {
  state: [],
  type: [],
  owner: [],
  subtitle: [],
  vehicleTitle: [],
  code: ['title'],
  occurredAt: ['dueDate'],
  leadQuality: [],
  amount: [],
};

export const CUSTOMER_INSIGHTS_GRID_FIELDS: Record<
  CustomerInsightsRecord['kind'] | CustomerInsightsAlert['kind'],
  CustomerInsightsGridFields
> = {
  interest: INTEREST_GRID_FIELDS,
  businessCase: BUSINESS_CASE_GRID_FIELDS,
  serviceCase: SERVICE_CASE_GRID_FIELDS,
  overdueInvoices: INVOICE_GRID_FIELDS,
  overdueTasks: TASK_GRID_FIELDS,
};
